import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

async function getPreSignedUrl(
  bucketName: string,
  key: string,
  accessToken: string,
  method: "GET" | "POST" | "PUT" | "DELETE"
): Promise<any> {
  try {
    let data = {
      BucketName: bucketName,
      Key: key,
      ContentType: "application/json",
      Method: method
    };

    const response = await axios.post(
      `${apiBaseUrl}/utilities/presignurl`,
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.log("Error:", error);
    throw Error("Error generating pre-signed URL");
  }
}

export default getPreSignedUrl;
